import { useAppState } from '../context/OmniboxJsonConverterContext';
import { RenderColumnsList } from '../omnibox_json_converter';
import {
  Box,
  Checkbox,
  Stack,
  TextField,
  Typography
} from '@mui/material';


function ColumnsList() {
  const { columnsExist, selectedColumns, globalColumns, setSelectedColumns, setSearchQuery } = useAppState();

  const allSelected = selectedColumns.length === globalColumns.length;
  const someSelected = selectedColumns.length > 0 && selectedColumns.length < globalColumns.length;

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setSelectedColumns(globalColumns);
    } else {
      setSelectedColumns([]);
    }
  }

  return (
    <Stack direction='column'>
      <Box component='section' sx={{
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 0.75,
        fontSize: '12px',
        color: 'text.secondary',
        p: 1,
        display: 'flex',
        flexDirection: 'column',
      }}>
        <Stack direction='row' spacing={1} alignItems='center' sx={{ pl: 4.75, mb: 0.5 }}>
          <Checkbox
            size='small'
            checked={allSelected}
            indeterminate={someSelected && !allSelected}
            onChange={handleSelectAll}
            sx={{
              height: 24,
              width: 24
            }}
          />
          <TextField
            size='small'
            placeholder='Search Columns...'
            autoComplete='off'
            onChange={(e) => setSearchQuery(e.target.value)}
            sx={{
              justifySelf: 'center',
              '& .MuiInputBase-input': {
                fontSize: 12
              }
            }}
          />
        </Stack>
        {columnsExist ? (<RenderColumnsList />) : (<Typography variant='body1' fontSize='12px'>No Columns Detected Yet.</Typography>)}
      </Box>

    </Stack>
  )
}

export default ColumnsList;